import axios from "axios";
import { ElMessage, ElLoading } from "element-plus";
import store from "@/store";
import router from "@/router";
import i18n from "@/locales";
import { aes_encrypt } from './aes.js'

const SIGN_TEXT_SUFFIX = 'cavity'

const t = i18n.global.t;

// 获取当前秒级时间戳，用于拼接签名原文。
function getSecondTimestamp() {
	return Math.floor(Date.now() / 1000)
}

// 按规则拼接签名原文，并使用 aes.js 生成请求头里的 sign。
function createSign() {
	const timestamp = getSecondTimestamp()
	const text = `${timestamp}___${SIGN_TEXT_SUFFIX}`
	return aes_encrypt(text)
}

const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_URL,
  timeout: 1000000,
});

let loadingInstance;

const getLocale = () => {
  return localStorage.getItem('locale') || 'zh-CN';
};

// 根据当前请求的 showLoading 配置关闭全屏 Loading。
const closeRequestLoading = (config) => {
  if (config?.showLoading === false || !loadingInstance) return;
  loadingInstance.close();
  loadingInstance = null;
};

service.interceptors.request.use(
  (config) => {
    if (store.state.token) {
      config.headers["Authorization"] = store.state.token;
    }
    config.headers["Accept-Language"] = getLocale();
    config.headers["sign"] = createSign();
    config.showLoading = config.showLoading !== false;
    if (config.showLoading) {
      loadingInstance = ElLoading.service({
        fullscreen: true,
        text: t('common.loading'),
      });
    }
    return config;
  },
  (error) => {
    closeRequestLoading(error.config);
    return Promise.reject(error);
  },
);

service.interceptors.response.use(
  (res) => {
    closeRequestLoading(res.config);
    const code = res.data.code;
    if (code === 0) {
      return Promise.resolve(res.data);
    } else if (code === 401) {
      console.log(res, '登录信息已失效，请重新登录');
      store.dispatch('logout').then(() => {
        router.replace('/home');
        ElMessage.error(t('common.sessionExpired'));
      });
      return Promise.reject(res.data);
    } else if (code === 499) {
      window.dispatchEvent(new CustomEvent('showMaintenancePage'));
      return Promise.reject("error");
    } else if (code === 500) {
      ElMessage.error(res.data.msg || t('common.serverError'));
      return Promise.reject(res.data || {});
    } else if (code === 601) {
      return Promise.reject("error");
    } else {
      return res.data;
    }
  },
  (error) => {
    console.log("err" + error);
    closeRequestLoading(error.config);

    let errorMsg = '请求失败';
    if (error.response) {
      switch (error.response.status) {
        case 401:
          store.dispatch('logout').then(() => {
            router.replace('/home');
            ElMessage.error('登录已过期，请重新登录');
          });
          break;
        case 404:
          errorMsg = '请求的资源不存在';
          break;
        case 500:
          errorMsg = '服务器内部错误';
          break;
        default:
          errorMsg = error.response.data?.msg || '请求失败';
      }
      ElMessage.error(errorMsg);
    } else if (error.request) {
      ElMessage.error('网络连接失败，请检查网络');
    } else {
      ElMessage.error('请求配置错误');
    }
    return Promise.reject(error);
  },
);

export default service;
